import type { FeatureGroup } from '../../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURE_GROUP: FeatureGroup = {
  guid: '6432313d-35c0-4e93-b355-006720bbff00',
  name: 'development:membership-portal',
  description: 'Membership Portal development tool — configure self-service member portals',
  product: 'app',
  parentGuid: DEVELOPMENT_FEATURE_GROUP.guid,
};
